const checkKey = (e,keyVerification,func) => {
    
    if (e.keyCode === keyVerification){
        return func ? func() : false;
    }
}

export default checkKey;